/* tslint:disable */
/* eslint-disable */
export enum WorkMeetingParticipantAttendanceStatusEnum {
  Pending = 'pending',
  Present = 'present',
  Absent = 'absent',
  Excused = 'excused'
}
